import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { all_routes } from "../../../router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { useEffect, useState } from "react";
import Spin from "antd/es/spin";
import { Toast } from "react-bootstrap";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Select } from "antd";

type Seminar = {
  id: number;
  title: string;
  date: string; // format: "YYYY-MM-DD"
  start_time: string; // format: "HH:MM:SS"
  end_time: string;   // format: "HH:MM:SS"

  state: number;
  state_name: string;

  zone: number;
  zone_name: string;

  branch: number;
  branch_name: string;

  audience_type: number;
  audience_type_name: string;

  program_type: number;
  program_type_name: string;

  seminar_status: number;
  seminar_status_name: string;

  response: number;
  response_name: string;

  remarks: string;
  members_attended_count: number;
  photo: string | null;

  seminar_conducted_by: number;
  seminar_conducted_by_name: string;

  created_at: string; // ISO timestamp
  updated_at: string; // ISO timestamp

  created_by: number;
  updated_by: number;

  classes: Array<number>;
  class_names: string;

  sections: Array<number>;
  section_names: string;

  orientations: Array<number>;
  orientation_names: string;

  is_active: boolean;
};



interface ErrorMessages {
  non_field_errors?: string[];
}

type Branch = {
  branch_id: number;
  name: string;
  label: string;
};

type AudienceType = {
  id: number;
  name: string;
};

type SeminarStatus = {
  id: number;
  name: string;
};

type ResponseType = {
  id: number;
  name: string;
};

type ConductedBy = {
  id: number;
  username: string;
}



const Seminors = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { webApi, userPermissions } = useUserPermissions();
  const [users, setUsers] = useState<Seminar[]>([]);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userId, setUserId] = useState<number | undefined>(undefined);
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = localStorage.getItem("wizklubOrientationsCurrentPage");
    return savedPage ? JSON.parse(savedPage) : 1;
  });

  useEffect(() => {
    localStorage.setItem(
      "wizklubOrientationsCurrentPage",
      JSON.stringify(currentPage)
    );
  }, [currentPage]);
  const [pageSize, setPageSize] = useState<number>(() => {
    const savedPageSize = localStorage.getItem("wizklubOrientationsPageSize");
    return savedPageSize ? Number(savedPageSize) : 10;
  });

  useEffect(() => {
    localStorage.setItem("wizklubOrientationsPageSize", pageSize.toString());
  }, [pageSize]);
  const [searchText, setSearchText] = useState<string>(() => {
    return localStorage.getItem("wizklubOrientationsSearchText") || "";
  });

  useEffect(() => {
    localStorage.setItem(
      "wizklubOrientationsSearchText",
      searchText
    );
  }, [searchText]);
  const [totalCount, setTotalCount] = useState();
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  const [branchesData, setBranchesData] = useState<Branch[]>([]);
  const [audienceTypesData, setAudienceTypesData] = useState<AudienceType[]>([]);
  const [seminarStatusesData, setSeminarStatusesData] = useState<SeminarStatus[]>([]);
  const [responsesData, setResponsesData] = useState<ResponseType[]>([]);
  const [conductedByData, setConductedBy] = useState<ConductedBy[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<number>(0);
  const [selectedAudience, setselectedAudience] = useState<number>(0);
  const [selectedSeminarStatus, setselectedSeminarStatus] = useState<number>(0);
  const [selectedResponse, setselectedResponse] = useState<number>(0);
  const [selectedConductedBy, setSelectedConductedBy] = useState<number>(0);
  const handleClearBranch = () => setSelectedBranch(0);
  const handleClearAudience = () => setselectedAudience(0);
  const handleClearSeminarStatus = () => setselectedSeminarStatus(0);
  const handleClearResponse = () => setselectedResponse(0);
  const handleClearConductedBy = () => setSelectedConductedBy(0);
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage]);
  const [isLoading, setIsLoading] = useState(false);
  const resetPasswordForm = () => {
    setNewPassword("");
    setConfirmPassword("");
    setErrorMessage({});
  };
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchBranches = async () => {
    const response = await fetch(`${webApi}/branches/wizklub_branches_dropdown/`, options)
    const data = await response.json();
    setBranchesData(data)
  }
  const fetchAudienceTypes = async () => {
    const response = await fetch(`${webApi}/seminars/audience_type_dropdown/`, options);
    const data = await response.json();
    setAudienceTypesData(data);
  };

  const fetchSeminarStatuses = async () => {
    const response = await fetch(`${webApi}/seminars/seminar_status_dropdown/`, options);
    const data = await response.json();
    setSeminarStatusesData(data);
  };

  const fetchResponses = async () => {
    const response = await fetch(`${webApi}/seminars/seminar_response_dropdown/`, options);
    const data = await response.json();
    setResponsesData(data);
  };

  const fetchConductedBy = async () => {
    const response = await fetch(`${webApi}/wizklub/wizklub_trainers_dropdown/`, options);
    const data = await response.json();
    setConductedBy(data);
  };

  const fetchUsersData = async (
    page: number,
    pageSize: number,
    searchText: string,
    branch: number,
    audience: number,
    semiarStatus: number,
    response1: number,
    conductedBy: number,
  ) => {
    let apiUrl = `${webApi}/seminars/seminar_orientation/?page=${page}&page_size=${pageSize}&search=${searchText}`
    if (branch) apiUrl += `&branch=${branch}`
    if (audience) apiUrl += `&audience_type=${audience}`
    if (semiarStatus) apiUrl += `&seminar_status=${semiarStatus}`
    if (response1) apiUrl += `&response=${response1}`
    if (conductedBy) apiUrl += `&seminar_conducted_by=${conductedBy}`
    const response = await fetch(
      apiUrl,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    branch: number,
    audience: number,
    semiarStatus: number,
    response1: number,
    conductedBy: number,
  ) => {
    setIsLoading(true); // Start loading
    try {
      const usersData = await fetchUsersData(page, pageSize, searchText, branch, audience, semiarStatus, response1, conductedBy);
      setUsers(usersData.results);
      setTotalCount(usersData.total_count);
      setCurrentPage(usersData.current_page_number);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!checkPermission("view_seminarorientation", "seminarorientation")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData(currentPage, pageSize, searchText, selectedBranch, selectedAudience, selectedSeminarStatus, selectedResponse, selectedConductedBy);
      fetchBranches();
      fetchAudienceTypes();
      fetchSeminarStatuses();
      fetchResponses();
      fetchConductedBy();
    }
  }, [userPermissions, currentPage, pageSize, searchText, selectedBranch, selectedAudience, selectedSeminarStatus, selectedResponse, selectedConductedBy]);

  const handlePasswordUpdate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        new_password: newPassword,
        confirm_password: confirmPassword,
      }),
    };

    try {
      const url = `${webApi}/user/changepassword/${userId}/`;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData);
        setToastMessage(errorData.non_field_errors);
        if (toastMessage !== "") {
          setShowSolidDangerToast(true);
        }
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Password updated successfully:", data);

      // Clear the input fields
      setNewPassword("");
      setConfirmPassword("");
      setErrorMessage({})

      const submitBtn = document.getElementById("submit-btn7");
      if (submitBtn) {
        submitBtn.setAttribute("data-bs-dismiss", "modal");
        submitBtn.click();
      }
    } catch (error) { }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const columns = [
    {
      title: (
        <span>
          Branch{selectedBranch !== 0 ? ` (${branchesData.find(branch => branch.branch_id === selectedBranch)?.name})` : ""}
          {selectedBranch !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearBranch}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "branch_name",
      key: "branch_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Branch"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = branchesData.find((b) => b.branch_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedBranch(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {branchesData.map((branch) => (
              <Select.Option key={branch.branch_id} value={branch.branch_id}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: (
        <span>
          Audience Type{selectedAudience !== 0 ? ` (${audienceTypesData.find(branch => branch.id === selectedAudience)?.name})` : ""}
          {selectedAudience !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearAudience}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "audience_type_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Audience Type"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = audienceTypesData.find((b) => b.id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setselectedAudience(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {audienceTypesData.map((branch) => (
              <Select.Option key={branch.id} value={branch.id}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { audience_type_name: string }) => record.audience_type_name === value,
    },

    {
      title: (
        <span>
          Orientation Status{selectedSeminarStatus !== 0 ? ` (${seminarStatusesData.find(branch => branch.id === selectedSeminarStatus)?.name})` : ""}
          {selectedSeminarStatus !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearSeminarStatus}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "seminar_status_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Seminar Status"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = seminarStatusesData.find((b) => b.id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setselectedSeminarStatus(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {seminarStatusesData.map((branch) => (
              <Select.Option key={branch.id} value={branch.id}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { seminar_status_name: string }) => record.seminar_status_name === value,
    },
    {
      title: (
        <span>
          Response{selectedResponse !== 0 ? ` (${responsesData.find(branch => branch.id === selectedResponse)?.name})` : ""}
          {selectedResponse !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearResponse}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "response_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Response"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = responsesData.find((b) => b.id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setselectedResponse(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {responsesData.map((branch) => (
              <Select.Option key={branch.id} value={branch.id}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { response_name: string }) => record.response_name === value,
    },
    {
      title: "Members Attended",
      dataIndex: "members_attended_count",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: (
        <span>
          Conducted By{selectedConductedBy !== 0 ? ` (${conductedByData.find(branch => branch.id === selectedConductedBy)?.username})` : ""}
          {selectedConductedBy !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearConductedBy}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "seminar_conducted_by_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Conducted By"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = conductedByData.find((b) => b.id === value);
              setSelectedKeys(selected ? [selected.username] : []);
              setSelectedConductedBy(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {conductedByData.map((branch) => (
              <Select.Option key={branch.id} value={branch.id}>
                {branch.username}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { seminar_conducted_by_name: string }) => record.seminar_conducted_by_name === value,
    },

    {
      title: "Action",
      dataIndex: "action",
      render: (_text: any, record: { id: any }) => (
        <div className="d-flex align-items-center">
          {checkPermission("change_seminarorientation", "seminarorientation") && (
            <Link
              className="btn btn-icon btn-sm btn-soft-info rounded-pill"
              to={routes.editSeminor}
              state={{ id: record.id }}
            >
              <i className="feather-edit" />
            </Link>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Orientations</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.crmLandingPage}>Dashboard</Link>
                  </li>
                  {/* <li className="breadcrumb-item">
                    <Link to="#">Academic </Link>
                  </li> */}
                  <li className="breadcrumb-item active" aria-current="page">
                    Orientations
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="mb-2">
                {checkPermission("add_seminarorientation", "seminarorientation") && (
                  <Link to={routes.addSeminor} className="btn btn-primary">
                    <i className="ti ti-square-rounded-plus-filled me-2" />
                    Add Orientation
                  </Link>
                )}
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}

          <div
            className="card"
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Orientation List</h4>
              <div className="d-flex align-items-center flex-wrap"></div>
            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}
              {/* Guardians List */}
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={users}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "20", "50", "100"],
                  }}
                  onChange={handleTableChange}
                  onSearch={handleSearch}
                />
              )}
              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="updatepassword"
          tabIndex={-1}
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "calc(100% - 1rem)",
            }}
          >
            <div
              className="modal-content"
              style={{
                maxWidth: "900px",
                padding: "20px",
                borderRadius: "10px",
                minWidth: "600px",
              }}
            >
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #dee2e6",
                  borderRadius: "10px 10px 0 0",
                }}
              >
                <h4 className="modal-title">Update Password</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="submit-btn7"
                  onClick={resetPasswordForm}
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form id="updatePasswordForm" onSubmit={handlePasswordUpdate}>
                <div
                  className="modal-body light-violet-bg"
                  style={{ padding: "20px" }}
                >
                  <div className="form-group">
                    <label className="form-label">New Password</label>
                    <input
                      type="password"
                      className={`form-control ${errorMessage.non_field_errors ? "is-invalid" : ""
                        }`}
                      name="new_password"
                      placeholder="New Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        minWidth: "500px",
                        minHeight: "55px",
                      }}
                    />
                    {errorMessage.non_field_errors && (
                      <div className="invalid-feedback">
                        {errorMessage.non_field_errors[0]}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="form-label" style={{ marginTop: "9px" }}>
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      className={`form-control ${errorMessage.non_field_errors ? "is-invalid" : ""
                        }`}
                      name="confirm_password"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        minWidth: "500px",
                        minHeight: "55px",
                      }}
                    />
                    {errorMessage.non_field_errors && (
                      <div className="invalid-feedback">
                        {errorMessage.non_field_errors[0]}
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-primary"
                      type="submit"
                      style={{ borderRadius: "5px" }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Seminors;
